<template>
  <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1959 11.53L2.19586 21.53C2.05369 21.6625 1.86564 21.7346 1.67134 21.7312C1.47704 21.7277 1.29165 21.649 1.15424 21.5116C1.01683 21.3742 0.938115 21.1888 0.934687 20.9945C0.931259 20.8002 1.00338 20.6122 1.13586 20.47L10.6046 11L1.13586 1.53C1.00338 1.38782 0.931259 1.19978 0.934687 1.00548C0.938115 0.811175 1.01683 0.62579 1.15424 0.488377C1.29165 0.350964 1.47704 0.272252 1.67134 0.268824C1.86564 0.265396 2.05369 0.337519 2.19586 0.469999L12.1959 10.47C12.3363 10.6106 12.4152 10.8012 12.4152 11C12.4152 11.1987 12.3363 11.3894 12.1959 11.53Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "ArrowRight",
}
</script>

<style scoped>

</style>
